<template>
    <b-modal title="Manage Columns" v-model="showModal" id="manage-columns" modal-class="modal-w-middle">

        <div class="content-switcher" v-if="canEditDefaultColumns">
            <span>Personal settings</span>
            <div class="content-switcher__slider">
                <input type="checkbox" id="content-switcher__slider" v-model="defaultSettings">
                <label for="content-switcher__slider"></label>
            </div>
            <span>Tracker-wide settings</span>
        </div>

<!--  -->
        <!-- <div class="content-switcher">
            <span>Personal settings</span>
            <div class="content-switcher__slider">
                <input type="checkbox" id="content-switcher__slider" v-model="defaultSettings">
                <label for="content-switcher__slider"></label>
            </div>
            <span>Tracker-wide settings</span>
        </div> -->
<!--  -->

        <p>Select the columns you want to display on the table and rearrange their order.</p>

        <header class="manage-columns__table-header">
            <p>Field</p>
            <p>Category</p>
        </header>

        <ColumnsSelect
            :table-type="tableType"
            :use-type="useType"
            :tracker-type="trackerType"
            :tracker-id="trackerId"
            class="list-manage mb-4"
            @changed="setColumns"
        />

        <template #modal-footer>
          <b-button variant="primary" size="lg" @click="saveColumns">Save</b-button>
        </template>
    </b-modal>
</template>

<script>

import user from '@/services/user.service'
import trackers from '@/services/trackers.service'
import ColumnsSelect from "@/components/manage/ColumnsSelect.vue";

export default {
    components: {
        ColumnsSelect,
    },

    props: {
        tableType: String,

        trackerId: {
            type: Number,
            default: 0,
        },

        trackerType: String,
    },

    data() {
        return {
            showModal: false,
            columns: {},
            profileFields: [],
            watchProfileFields: false,
            watchColumnsProfileFields: true,
            canEditDefaultColumns: false,
            defaultSettings: false,
        }
    },

    computed: {
        useType() {
            if (this.defaultSettings) {
                return 'default'
            } else {
                return 'personal'
            }
        },
    },

    methods: {
        open() {
            this.defaultSettings = false

            if (this.trackerId) {
                trackers.getUserPermissions(this.trackerId).then(response => {
                    let userPermissions = response.data

                    if (userPermissions.indexOf('tracker-manage-default-columns') >= 0) {
                        this.canEditDefaultColumns = true
                    }
                })
            }

            this.showModal = true;
        },

        setColumns(columns) {
            this.columns = {...columns};
        },

        saveColumns() {
            this.showModal = false;

            user.updateColumns(this.tableType, this.useType, this.trackerId, this.columns).then(() => {
                if (this.useType !== "default") {
                    this.$emit('changeColumns')
                }
            })
        },
    }
}
</script>

<style scoped>

</style>
